import React from "react";
import { observer } from "mobx-react";
import { useEffect } from "react";
import PlusIcon from "../../../../../images/membership/plus-white.svg";
import styled from "styled-components";
import { MediaTypes } from "../enums";
import { MediaGridResponseModel, MediaModel } from "../models";
import {
  CustomLabel,
  FlexContainer,
  IOption,
  ModalComponent,
  PaginationModel,
  SingleSelect,
  TablePagination,
} from "@mindmemobile/mm-shared-global";
import { AuthService, MediaService } from "../services";
import { ItemImage } from "../styles";
import { MediaStore } from "../store";

type IProps = {
  allowedMediaTypes?: MediaTypes[];
  mediaStore: MediaStore;
  onClose: () => void;
  onUpload: (media: MediaModel) => void;
};

const mediaOptions: IOption[] = [
  { value: "image", label: MediaTypes.Image },
  { value: "video", label: MediaTypes.Video },
];
export const LibraryMediaWrapper = styled.div`
  .media-blocks {
    max-width: 100px;
    label {
      word-break: break-word;
      line-height: 16px;
    }
  }
  .library-popup-pagination {
    border: none;
    padding: 0px 20px;
    background-color: #f4f7fb;
    > div:first-child {
      width: 145px;
      text-align: left;
    }
  }
  .media-type-select {
    width: 300px !important;
  }
  .library-image-label {
    /* max-width: 50ch;
    text-overflow: ellipsis; */
    /* white-space: nowrap; */
    /* overflow: hidden;
    width: auto; */
    line-height: 22px !important;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* Number of lines to display */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const MediaLibraryPopUp: React.FC<IProps> = ({
  allowedMediaTypes,
  mediaStore,
  onClose,
  onUpload,
}) => {
  useEffect(() => {
    loadLibraryData(
      mediaStore.pagination.pageNumber,
      mediaStore.pagination.pageSize,
      "",
      mediaStore.mediaOption
    );
  }, []);

  const loadLibraryData = async (
    pageNumber: number,
    pageSize: number,
    searchValue: string,
    filter: string
  ) => {
    const response = await MediaService.getMedias(
      AuthService.authData.accountId,
      pageNumber,
      pageSize,
      filter,
      searchValue
    ).toPromise();

    if (response) {
      const medias =
        response.result?.map((m: any) =>
          MediaGridResponseModel.deserializeAPIModel(m)
        ) || [];
      mediaStore.updateMedias(medias || []);
      const pagination = PaginationModel.deserialize(response.meta);
      mediaStore.updatePagination(pagination);
    }
  };

  function onPaginationChange(pageNumber: number, pageSize: number) {
    loadLibraryData(pageNumber, pageSize, mediaStore.searchValue, "");
  }

  const renderMedia = (media: MediaGridResponseModel) => {
    switch (media.type) {
      case MediaTypes.Video:
        return (
          <video style={{ width: "100%" }} controls={true}>
            <source type="video/ogg" src={media.url} />
            <source type="video/m4v" src={media.url} />
            <source type="video/mp4" src={media.url} />
            <source type="video/youtube" src={media.url} />
          </video>
        );
      default:
        return <img src={media.url} className="product-image" />;
    }
  };

  const onClickMedia = (media: MediaGridResponseModel) => {
    const mediaModel = MediaModel.fromMediaGridResponseModel(media);
    mediaStore.updateMediaOption(mediaOptions[0].value);
    onUpload(mediaModel);
  };

  const onSingleSelectChange = (value: string) => {
    mediaStore.updateMediaOption(value);
    loadLibraryData(
      mediaStore.pagination.pageNumber,
      mediaStore.pagination.pageSize,
      mediaStore.searchValue,
      value
    );
  };

  const onClosePopup = () => {
    mediaStore.updateMediaOption(mediaOptions[0].value);
    onClose();
  };

  const renderModalBody = () => {
    const filterAllowedMediaTypes = allowedMediaTypes
      ? mediaOptions.filter((m) => allowedMediaTypes.some((t) => t == m.label))
      : mediaOptions;
    return (
      <div>
        <FlexContainer>
          <SingleSelect
            selectedKey={mediaStore.mediaOption}
            searchable={false}
            nameKeys={["label"]}
            valueKeys={["value"]}
            options={[filterAllowedMediaTypes || []]}
            onChange={(option: any) => onSingleSelectChange(option.value)}
            className="media-type-select"
          />
        </FlexContainer>
        <FlexContainer
          fxLayout="row"
          spacing={30}
          fxWrap="wrap"
          padding="30px 0px 0px"
        >
          {mediaStore.medias.map((m, idx) => {
            return (
              <div
                key={idx}
                onClick={() => onClickMedia(m)}
                className="media-blocks"
              >
                <ItemImage bgColor="#ebeaea82">
                  {m.url && renderMedia(m)}
                  <div className="overlay-product">
                    <img src={PlusIcon} className="plus-hovered" />
                  </div>
                </ItemImage>
                <CustomLabel
                  fontSize="12px"
                  fontWeight="600"
                  className="library-image-label"
                >
                  {m.name}
                </CustomLabel>
              </div>
            );
          })}
        </FlexContainer>
      </div>
    );
  };

  return (
    <LibraryMediaWrapper>
      <ModalComponent
        title="Upload Media"
        titleFontSize="22px"
        bodyPadding="50px 61px"
        showFooter={true}
        minHeight="440px"
        wrapperWidth="750px"
        bodyBackgroundColor="#fefefe"
        footerBackground="#F4F7FB"
        footerHeight="auto"
        onClose={() => onClosePopup()}
        footerContent={
          <>
            {" "}
            <TablePagination
              onPageChange={(pageNumber: number) =>
                onPaginationChange &&
                onPaginationChange(pageNumber, mediaStore.pagination.pageSize)
              }
              onPageSizeChange={(pageSize: number) =>
                onPaginationChange && onPaginationChange(1, pageSize)
              }
              pagination={mediaStore.pagination}
              className="library-popup-pagination"
            />
          </>
        }
      >
        {renderModalBody()}
      </ModalComponent>
    </LibraryMediaWrapper>
  );
};

export default observer(MediaLibraryPopUp);
